import {isTodayBetweenDates} from '@Utils/date.util';

export enum SeasonalDecorationEmoji {
  HALLOWEEN = '🎃',
  CHRISTMAS = '🎄',
}

export const isHalloweenSeason = (): boolean => {
  const currentYear = new Date().getFullYear();
  // kabirTodo: revert this later
  const lowerBound = new Date(currentYear, 7, 1);
  // const lowerBound = new Date(currentYear, 8, 1);
  const upperBound = new Date(currentYear, 10, 1);
  return isTodayBetweenDates(lowerBound, upperBound);
};

export const isChristmasSeason = (): boolean => {
  const currentYear = new Date().getFullYear();
  const lowerBound = new Date(currentYear, 10, 2);
  const upperBound = new Date(currentYear, 11, 26);
  return isTodayBetweenDates(lowerBound, upperBound);
};
